import Component from '../core/Component'
import withMedia from '../core/withMedia'
import Scroll from '../services/Scroll'
import EventBus from '../core/EventBus'

const defaults = {
    media: 'mediumUp',
}

class FooterFixedPortfolio extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            content: null,
        }

        this.state = {
            height: 0,
            limit: 0,
        }
    }

    prepare() {
        if (window.innerHeight >= 730 && window.innerWidth >= 1439) {
            Scroll.on('resize', this.handleResize)
            Scroll.on('scroll', this.handleScroll)
            this.resize()
            this.render(Scroll.getScroll().y)
        }

        EventBus.on('footer:closed', this.resetHeight)
        EventBus.on('footer:resize', this.resetHeight)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
        EventBus.off('footer:closed', this.resetHeight)
        EventBus.off('footer:resize', this.resetHeight)
        this.ref.content.removeAttribute('style')
        this.element.removeAttribute('style')
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = (data) => {
        this.render(data.offset.y)
    }

    resize() {
        const box = this.ref.content.getBoundingClientRect()
        this.state.height = box.height
        this.state.min = box.top + Scroll.getScroll().y
        this.state.limit = Scroll.getLimit().y
        this.element.style.height = this.state.height + 'px'
        this.render(Scroll.getScroll().y)
    }

    render(y) {
        if (this.state.limit - y > this.state.height) return
        this.ref.content.style.transform = `translateY(${Math.min(y - this.state.limit, 0)}px)`
    }

    resetHeight = () => {
        this.element.style.height = ''
    }
}

export default withMedia(FooterFixedPortfolio)
